var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"item_details"},_vm._l((_vm.detailsInfoList),function(item,index){return _c('div',{staticClass:"details_info"},[_c('img',{attrs:{"src":item.image,"alt":""}}),_c('div',[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }